import React, { useState } from "react";
import WebHome from "./WebHome";
import WebAboutMe from "./WebAboutMe";
import WebPortfolio from "./WebPortfolio";
import WebBiography from "./WebBiography";
import WebContactMe from "./WebContactMe";
import SetupGuideModal from "./SetupGuideModal";

/*
  Personal Portfolio manager — wraps the existing Web* edit forms as tabs
  so the whole portfolio is editable from a single "My Websites" entry.
  props: userData
*/
export default function PersonalWebsiteManager({ userData }) {
    const [tab, setTab] = useState("home");

    const tabs = [
        ["home", "Home"],
        ["about", "About Me"],
        ["portfolio", "Portfolio"],
        ["biography", "Biography"],
        ["contact", "Contact Me"],
    ];

    const uid = userData?.personaluid || userData?.userselfuid || "me";

    return (
        <div className="container-fluid py-2" style={{ maxWidth: 980 }}>
            <div className="d-flex justify-content-between align-items-center mb-3">
                <h5 className="fw-bold mb-0">Personal Portfolio Website</h5>
                <SetupGuideModal
                    storageKey={`dn_guide_personal_${uid}`}
                    title="Set up your Portfolio Website"
                    intro="Welcome! Fill these sections to build your personal website. It takes just a few minutes."
                    steps={[
                        { title: "Home", desc: "Add your name, a short slogan and a background/hero image URL." },
                        { title: "About Me", desc: "Write your bio, upload your profile photo, and add experience & languages." },
                        { title: "Portfolio", desc: "Upload photos of your work, events or achievements." },
                        { title: "Biography", desc: "Add key milestones or a short life/career timeline (optional)." },
                        { title: "Contact Me", desc: "Add phone, WhatsApp, email, address and social links." },
                    ]}
                />
            </div>

            <ul className="nav nav-tabs mb-3">
                {tabs.map(([k, label]) => (
                    <li className="nav-item" key={k}>
                        <button className={`nav-link ${tab === k ? "active" : ""}`} onClick={() => setTab(k)}>
                            {label}
                        </button>
                    </li>
                ))}
            </ul>

            {tab === "home" && <WebHome userData={userData} />}
            {tab === "about" && <WebAboutMe userData={userData} />}
            {tab === "portfolio" && <WebPortfolio userData={userData} />}
            {tab === "biography" && <WebBiography userData={userData} />}
            {tab === "contact" && <WebContactMe userData={userData} />}
        </div>
    );
}
